export const theme = {
  colors: {
    primary: '#1a2a3a',    // Dark navy - professional
    primaryLight: '#2c3e50',
    secondary: '#c4a484',   // Soft gold - elegant
    secondaryLight: '#d4b896',
    background: '#ffffff',  // Pure white - clean
    backgroundAlt: '#f8f9fa',  // Light gray - for sections
    text: '#2c3e50',        // Dark blue-gray
    textLight: '#6c757d',   // Muted text
    light: '#ffffff',
    accent: '#8a6d4b',      // Bronze accent
    accentHover: '#a68b5b',
    border: '#e9ecef',
    shadow: 'rgba(26, 42, 58, 0.1)',
    overlay: 'rgba(26, 42, 58, 0.6)'
  },
  fonts: {
    heading: '"Playfair Display", Georgia, serif',
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
  },
  spacing: {
    section: '100px',
    container: '1400px'
  },
  shadows: {
    small: '0 2px 8px rgba(26, 42, 58, 0.08)',
    medium: '0 4px 20px rgba(26, 42, 58, 0.12)',
    large: '0 10px 40px rgba(26, 42, 58, 0.15)',
    hover: '0 20px 50px rgba(26, 42, 58, 0.2)'
  },
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease'
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px'
  }
};
